import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Button, Carousel } from "react-bootstrap";
import useTitle from "../../hooks/useTitle";
import {
  FaEnvelope,
  FaUser,
  FaUserShield,
  FaCheckCircle,
  FaTags,
  FaStar,
  FaBoxes,
  FaChevronDown,
} from "react-icons/fa";
import { useState, useEffect } from "react";
import "../../App.css";
import {
  FaFileInvoiceDollar,
  FaBook,
  FaGem,
  FaUsers,
  FaBaby,
  FaPhoneAlt,
} from "react-icons/fa";
import {
  GiStarsStack,
  GiBookCover,
  GiCrystalBall,
  GiNotebook,
  GiAries,
  GiTaurus,
  GiGemini,
  GiCancer,
  GiLeo,
  GiVirgo,
  GiLibra,
  GiScorpio,
  GiSagittarius,
  GiCapricorn,
  GiAquarius,
  GiPisces,
} from "react-icons/gi";
const products = [
  {
    name: "Finance Report",
    icon: <FaFileInvoiceDollar size={50} color="#FFF" />,
  },
  { name: "Cosmic Code", icon: <GiStarsStack size={50} color="#FFF" /> },
  { name: "Lal Kitab Report", icon: <GiBookCover size={50} color="#FFF" /> },
  {
    name: "Fortune Plus Report",
    icon: <GiCrystalBall size={50} color="#FFF" />,
  },
  {
    name: "Book Consultation Call",
    icon: <FaPhoneAlt size={50} color="#FFF" />,
  },
  { name: "Lal Kitab Webinar", icon: <GiNotebook size={50} color="#FFF" /> },
  { name: "Occult Gurukul", icon: <FaBook size={50} color="#FFF" /> },
  { name: "Gemsmantra", icon: <FaGem size={50} color="#FFF" /> },
  {
    name: "Mega Numerology Webinar",
    icon: <GiNotebook size={50} color="#FFF" />,
  },
  {
    name: "Kaal Sarp & Manglik Dosh Report, Fortune Report",
    icon: <GiCrystalBall size={50} color="#FFF" />,
  },
  { name: "Couple Kundali", icon: <FaUsers size={50} color="#FFF" /> },
  { name: "Baby Name Report", icon: <FaBaby size={50} color="#FFF" /> },
  { name: "Buy Gemstones", icon: <FaGem size={50} color="#FFF" /> },
  { name: "Our Courses", icon: <FaBook size={50} color="#FFF" /> },
  { name: "Buy Rudraksha", icon: <FaGem size={50} color="#FFF" /> },
];
const medias = [
  "सकारात्मक परिवर्तन के साथ ही आगे बढ़ा जा सकता हैः पंडित",
  "ज्योतिष और अंकशास्त्र से कैसे होगा आपकी समस्या का समाधान, Astro पंडित ने बताया",
  "Pandit Ji: Bridging Ancient Wisdom With Modern Science",
  "Astro Pandit Unveils 'Main Aisa Kyun Hoon?' – A Revolutionary OTT Series on Astrology",
  "Why 'Main Aisa Kyun Hoon?' OTT Series Is a Must-Watch for Gen Z",
  "Astro Pandit announces a donation drive 'Ramnavmi Daan Maha Abhiyan",
  "JioHotstar पर रिलीज हुई 'मैं ऐसा क्यों हूं' की नई सीरीज, पढ़ें डिटेल्स",
  "Asia's Best Numerologist Online: Astro Pandit Emerges As A Guiding Light In Numerology",
];
const freeCalculators = [
  "Free Panchang",
  "Free Nakshatra",
  "Free Kundali Matching",
  "Free Moon Sign",
];
const Courses = [
  "Advanced Astrology Course",
  "Advanced Numerology Course",
  "Lal Kitab Course",
];
const testimonials = [
  {
    name: "John Doe",
    feedback: "Astro Pandit changed my life. Accurate predictions!",
  },
  {
    name: "Priya Sharma",
    feedback: "Great experience with numerology sessions.",
  },
  {
    name: "Amit Verma",
    feedback: "His consultation gave me clarity in career decisions.",
  },
  {
    name: "Neha Gupta",
    feedback: "The Kundli matching was very helpful for my marriage.",
  },
  {
    name: "Rahul Mehta",
    feedback: "Very professional and insightful guidance.",
  },
  { name: "Anjali Singh", feedback: "Loved the personalized kundli report!" },
  { name: "Vikram Kapoor", feedback: "Practical remedies that actually work." },
  {
    name: "Sneha Joshi",
    feedback: "Highly recommended for astrology & numerology.",
  },
];
const chunkArray = (arr, size) =>
  arr.reduce(
    (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
    []
  );

const faqs = [
  {
    question: "What services do you provide?",
    answer:
      "We provide astrology, numerology, palmistry, and personalized consultation services.",
  },
  {
    question: "How can I book a consultation?",
    answer:
      "You can book directly from our website under the 'Book Consultation Call' section.",
  },
  {
    question: "Do you provide online courses?",
    answer:
      "Yes, we offer both beginner and advanced courses in Astrology and Numerology.",
  },
  {
    question: "Can I collaborate with you?",
    answer: "Of course! Visit our 'Collaborate With Us' page to get started.",
  },
];
export default function Home() {
  useTitle("Astrologer Home | Astro Portal");
  const [openIndex, setOpenIndex] = useState(null);
  const testimonialChunks = chunkArray(testimonials, 4);
  const Counter = ({ target, suffix }) => {
    const [count, setCount] = useState(0);
    useEffect(() => {
      let start = 0;
      const duration = 2000; // 2 sec
      const stepTime = Math.abs(Math.floor(duration / target));
      const timer = setInterval(() => {
        start += 1;
        setCount(start);
        if (start >= target) clearInterval(timer);
      }, stepTime);
      return () => clearInterval(timer);
    }, [target]);
    return (
      <h2 className="text-4xl font-bold text-orange-500">
        {count}
        {suffix}
      </h2>
    );
  };
  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <>
      {/* Header Banner (Carousel) */}
      <Carousel>
        <Carousel.Item>
          <div className="banner-size">
            <img
              className="img-fluid"
              src="./images/banner_1.jpg"
              alt="First slide"
            />
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="banner-size">
            <img
              className="img-fluid"
              src="./images/banner_2.jpg"
              alt="Second slide"
            />
          </div>
        </Carousel.Item>
      </Carousel>

      {/* Services Section */}
      <section id="products" className="py-5">
        <Container>
          <div className="w-100 text-center">
            <h2 className="mb-4 border-bottom-golden text-maroon">
              Our Services
            </h2>
          </div>
          <Row>
            {products.map((product, i) => (
              <Col md={3} sm={6} xs={12} className="mb-4" key={i}>
                <Card className="h-100 product-card text-center shadow-lg">
                  <div className="circle-image mx-auto mt-4 bg-orange p-3 rounded-circle">
                    {product.icon} {/* Render the icon here */}
                  </div>
                  <Card.Body>
                    <Card.Title className="mt-3">{product.name}</Card.Title>
                    <Card.Text>
                      Authentic {product.name.toLowerCase()} to bring positivity
                      and prosperity.
                    </Card.Text>
                    <Button
                      variant="warning"
                      className="order-btn fw-bold text-white"
                    >
                      Order Now
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* media section */}
      <section id="media" className="py-5">
        <Container>
          <div className="w-100 text-center">
            <h2 className="mb-4 border-bottom-golden text-maroon">
              In The Media
            </h2>
          </div>
          <Row>
            {medias.map((media, i) => (
              <Col md={3} sm={6} xs={12} className="mb-4" key={i}>
                <Card className="h-100 media-card text-center shadow-lg">
                  <div className="circle-image mx-auto mt-4">
                    <img
                      src={`./images/media_${i + 1}.jpg`}
                      alt={media}
                      className="img-fluid"
                    />
                  </div>
                  <Card.Body>
                    <Card.Title className="mt-3 text-maroon">
                      {media}
                    </Card.Title>
                    <Button
                      variant="warning"
                      className="order-btn fw-bold text-white"
                    >
                      Read More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            {/* Left Side - Image */}
            <Col md={6} className="text-center mb-4 mb-md-0">
              <img
                src="./images/about_us.jpg"
                alt="About Us"
                className="img-fluid rounded shadow-lg"
                style={{ maxHeight: "400px", objectFit: "cover" }}
              />
            </Col>

            {/* Right Side - Content */}
            <Col md={6}>
              <h2 className="fw-bold mb-3 text-maroon">
                Astrology: Your Guide To Life's Journey & Path To Success!
              </h2>
              <p className="text-muted mb-4 fs-5">
                We are dedicated to providing authentic astrology services that
                help individuals discover their life’s true potential. Our
                experienced astrologers specialize in Vedic Astrology,
                Numerology, and spiritual guidance to bring positivity, peace,
                and prosperity in your life.
              </p>
              <p className="text-muted mb-4 fs-5">
                With years of trust and excellence, we aim to combine
                traditional knowledge with modern solutions, helping you make
                better decisions for a successful and happy future.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* counter Section */}
      <section id="astrologers" className="py-5 bg-maroon text-white">
        <Container>
          <div className="container py-5">
            <div className="d-flex flex-wrap justify-content-center justify-content-md-between text-center gap-3">
              <div className="counter-circle">
                <Counter target={200} suffix="k+" />
                <p className="fw-bold mb-0">Kundli Served</p>
              </div>

              <div className="counter-circle">
                <Counter target={50} suffix="+" />
                <p className="fw-bold mb-0">Year's Of Legacy</p>
              </div>

              <div className="counter-circle">
                <Counter target={50} suffix="k+" />
                <p className="fw-bold mb-0">Students Enrolled</p>
              </div>

              <div className="counter-circle">
                <Counter target={100} suffix="k+" />
                <p className="fw-bold mb-0">Consultations Given</p>
              </div>

              <div className="counter-circle">
                <Counter target={5} suffix="+" />
                <p className="fw-bold mb-0">Languages For Reports</p>
              </div>

              <div className="counter-circle">
                <Counter target={20} suffix="+" />
                <p className="fw-bold mb-0">Awards in the field of Occult</p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* free calculators section */}
      <section id="media" className="py-5">
        <Container>
          <div className="w-100 text-center">
            <h2 className="mb-4 border-bottom-golden text-maroon">
              Free Calculators
            </h2>
          </div>
          <Row>
            {freeCalculators.map((calculator, i) => (
              <Col md={6} sm={12} className="mb-4" key={i}>
                <Card className="h-100 calculator-card text-start shadow-lg">
                  <div className="circle-image ps-3 mt-4">
                    <img
                      src={`./images/calculator_${i + 1}.jpg`}
                      alt={calculator}
                      className="img-fluid"
                    />
                  </div>
                  <Card.Body>
                    <Card.Title className="mt-3 fs-4 text-orange">
                      {calculator}
                    </Card.Title>
                    <p>With Horoscope, Kundali, And Predictions</p>
                    <Button
                      variant="warning"
                      className="bg-orange fw-bold text-white"
                    >
                      Get it Now
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Book Consultation Section */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            {/* left Side - Content */}
            <Col md={7}>
              <h2 className="fw-bold mb-3 text-maroon">
                Book a Consultation Call with the Best Astrologer in India!
              </h2>
              <p className="text-muted mb-4 fs-5 text-justify">
                We believe astrology is pure science, and we aim to create such
                a social impact of the organization on you that science and
                astrology through its resources of the astrology chart, kundali,
                etc,. As we dive into our 50th year, we strive to build a
                community where we are a part of your daily routine right from
                our astrology by date of birth, name, time, palm reading, and
                face reading, to all other online astrology, numerology,
                palmistry services.
              </p>
              <Button
                variant="warning"
                className="bg-orange fw-bold text-white"
              >
                Book Now
              </Button>
            </Col>
            {/* right Side - Image */}
            <Col md={5} className="text-center mb-4 mb-md-0">
              <img
                src="./images/about_us.jpg"
                alt="About Us"
                className="img-fluid rounded shadow-lg"
                style={{ maxHeight: "400px", objectFit: "cover" }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Courses section */}
      <section id="media" className="py-5">
        <Container>
          <div className="w-100 text-center">
            <h2 className="mb-4 border-bottom-golden text-maroon">
              Explore Our Courses
            </h2>
          </div>
          <Row>
            {Courses.map((course, i) => (
              <Col
                md={4}
                sm={12}
                className="mb-4 mx-auto"
                style={{ maxWidth: "400px" }}
                key={i}
              >
                <Card className="h-100 course-card text-start shadow-lg">
                  <div className="ps-3 mt-4">
                    <img
                      src={`./images/course_${i + 1}.jpg`}
                      alt={course}
                      className="img-fluid"
                    />
                  </div>
                  <Card.Body>
                    {/* Title with icons */}
                    <Card.Title className="mt-3 fs-5 d-flex align-items-center">
                      <div className="d-flex align-items-center mb-2">
                        <div className="d-flex align-items-start">
                          <FaEnvelope className="text-maroon me-2 mt-1" />
                          <span className="fs-6 text-maroon">
                            Certified Course
                          </span>
                        </div>
                      </div>

                      <div className="d-flex align-items-center">
                        <div className="d-flex align-items-start">
                          <FaUser className="text-maroon me-2 mt-1" />
                          <span className="fs-6 text-maroon">
                            500+ Students Enrolled
                          </span>
                        </div>
                      </div>
                    </Card.Title>

                    {/* Centered smaller button */}
                    <div className="text-center mt-3">
                      <Button
                        variant="warning"
                        size="sm"
                        className="order-btn fw-bold text-white px-3"
                        href={course} // dynamic value from course object
                      >
                        Enroll Now
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* counter Section */}
      <section id="astrologers" className="py-5 bg-maroon text-white">
        <Container>
          <div className="container py-5">
            <div className="d-flex flex-wrap justify-content-center justify-content-md-between text-center gap-4">
              {/* Licensed Guide */}
              <div className="text-center">
                <div className="counter-circle d-flex align-items-center justify-content-center">
                  <FaUserShield size={80} className="text-maroon" />
                </div>
                <p className="fs-6 fw-bold mb-0 pt-3">Licensed Guide</p>
              </div>

              {/* Gemstone Activation */}
              <div className="text-center">
                <div className="counter-circle d-flex align-items-center justify-content-center">
                  <FaGem size={80} className="text-maroon" />
                </div>
                <p className="fs-6 fw-bold mb-0 pt-3">Gemstone Activation</p>
              </div>

              {/* Authentic Products */}
              <div className="text-center">
                <div className="counter-circle d-flex align-items-center justify-content-center">
                  <FaCheckCircle size={80} className="text-maroon" />
                </div>
                <p className="fs-6 fw-bold mb-0 pt-3">Authentic Products</p>
              </div>

              {/* Best Pricing */}
              <div className="text-center">
                <div className="counter-circle d-flex align-items-center justify-content-center">
                  <FaTags size={80} className="text-maroon" />
                </div>
                <p className="fs-6 fw-bold mb-0 pt-3">Best Pricing</p>
              </div>

              {/* Astrologically Verified */}
              <div className="text-center">
                <div className="counter-circle d-flex align-items-center justify-content-center">
                  <FaStar size={80} className="text-maroon" />
                </div>
                <p className="fs-6 fw-bold mb-0 pt-3">
                  Astrologically Verified
                </p>
              </div>

              {/* Wide Variety Of Products */}
              <div className="text-center">
                <div className="counter-circle d-flex align-items-center justify-content-center">
                  <FaBoxes size={80} className="text-maroon" />
                </div>
                <p className="fs-6 fw-bold mb-0 pt-3">
                  Wide Variety Of Products
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="py-5 bg-light text-center">
        <h2 className="fw-bold text-maroon">
          Know What Your Zodiac Sign Says About You
        </h2>
        <p className="mb-5">
          Click on the Rashi to know about your Personality, Traits, Life
          Predictions, and Remedies!
        </p>

        <div className="container">
          <div className="row g-4">
            {/* First Row */}
            <div className="col-6 col-md-2">
              <GiAries size={40} className="text-maroon" />
              <p className="mt-2">Aries</p>
            </div>
            <div className="col-6 col-md-2">
              <GiTaurus size={40} className="text-maroon" />
              <p className="mt-2">Taurus</p>
            </div>
            <div className="col-6 col-md-2">
              <GiGemini size={40} className="text-maroon" />
              <p className="mt-2">Gemini</p>
            </div>
            <div className="col-6 col-md-2">
              <GiCancer size={40} className="text-maroon" />
              <p className="mt-2">Cancer</p>
            </div>
            <div className="col-6 col-md-2">
              <GiLeo size={40} className="text-maroon" />
              <p className="mt-2">Leo</p>
            </div>
            <div className="col-6 col-md-2">
              <GiVirgo size={40} className="text-maroon" />
              <p className="mt-2">Virgo</p>
            </div>

            {/* Second Row */}
            <div className="col-6 col-md-2">
              <GiLibra size={40} className="text-maroon" />
              <p className="mt-2">Libra</p>
            </div>
            <div className="col-6 col-md-2">
              <GiScorpio size={40} className="text-maroon" />
              <p className="mt-2">Scorpio</p>
            </div>
            <div className="col-6 col-md-2">
              <GiSagittarius size={40} className="text-maroon" />
              <p className="mt-2">Sagittarius</p>
            </div>
            <div className="col-6 col-md-2">
              <GiCapricorn size={40} className="text-maroon" />
              <p className="mt-2">Capricorn</p>
            </div>
            <div className="col-6 col-md-2">
              <GiAquarius size={40} className="text-maroon" />
              <p className="mt-2">Aquarius</p>
            </div>
            <div className="col-6 col-md-2">
              <GiPisces size={40} className="text-maroon" />
              <p className="mt-2">Pisces</p>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-light py-5">
        <div className="container text-center">
          <h2 className="text-maroon mb-4">What Our Clients Say</h2>
          <Carousel indicators={false} interval={3000}>
            {testimonialChunks.map((group, idx) => (
              <Carousel.Item key={idx}>
                <div className="row">
                  {group.map((t, i) => (
                    <div className="col-md-3 mb-3" key={i}>
                      <div className="p-3 shadow rounded bg-white h-100">
                        <p className="fst-italic">"{t.feedback}"</p>
                        <h6 className="fw-bold mt-3">{t.name}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4 text-maroon fw-bold">
            Frequently Asked Questions
          </h2>
          <div className="accordion">
            {faqs.map((faq, index) => (
              <div key={index} className="mb-3 border rounded">
                <button
                  className="w-100 d-flex justify-content-between align-items-center p-3 bg-white border-0 text-start"
                  onClick={() => toggleFaq(index)}
                >
                  <span className="fw-semibold">{faq.question}</span>
                  <FaChevronDown
                    className={`transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  className={`px-3 overflow-hidden transition-all`}
                  style={{
                    maxHeight: openIndex === index ? "200px" : "0px",
                    transition: "max-height 0.3s ease",
                  }}
                >
                  <p className="py-2 mb-0">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
